import type { ArrayElement } from 'types/utils';

export const ACCOUNT_VIEWS_IDS = [
  'public_tags',
] as const;

export type AccountViewsId = ArrayElement<typeof ACCOUNT_VIEWS_IDS>;
